import { render, staticRenderFns } from "./CrearContrato.vue?vue&type=template&id=74c35a89&scoped=true"
import script from "./CrearContrato.vue?vue&type=script&lang=js"
export * from "./CrearContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c35a89",
  null
  
)

export default component.exports